import React, { useCallback, useEffect, useRef } from 'react';

export type AsyncDispatch<A, S> = (action: A) => Promise<S>;

export function useAsyncDispatch<S, A>(state: S, dispatch: React.Dispatch<A>): AsyncDispatch<A, S> {
  type PromiseResolver = (value: S) => void;
  type PromiseRejector = (reason?: any) => void;

  const resolvePromise = useRef<PromiseResolver>();
  const rejectPromise = useRef<PromiseRejector>(); // TODO: use or remove

  useEffect(() => {
    if (resolvePromise.current) {
      resolvePromise.current(state);
      resolvePromise.current = undefined;
      rejectPromise.current = undefined;
    }
  }, [state]);

  const dispatchAsync = useCallback(
    (action: A): Promise<S> => {
      return new Promise<S>((resolve, reject) => {
        resolvePromise.current = resolve;
        rejectPromise.current = reject;
        dispatch(action);
      });
    },
    [dispatch],
  );

  return dispatchAsync;
}
